import directive from './directive';
import service from './service';
export let _Vue;

export default {
  install(Vue) {
    _Vue = Vue;
    Vue.use(directive);
    Vue.prototype.$loading = service;
  },
  directive,
  service
};
